var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 2.57129H7.4375C7.20312 1.43066 6.20312 0.571289 5 0.571289C3.78125 0.571289 2.78125 1.43066 2.54688 2.57129H0.5C0.21875 2.57129 0 2.80566 0 3.07129C0 3.35254 0.21875 3.57129 0.5 3.57129H2.54688C2.78125 4.71191 3.78125 5.57129 5 5.57129C6.20312 5.57129 7.20312 4.72754 7.4375 3.57129H9.5C9.76562 3.57129 10 3.35254 10 3.07129C10 2.80566 9.76562 2.57129 9.5 2.57129ZM5 4.32129C4.29688 4.32129 3.75 3.77441 3.75 3.07129C3.75 2.38379 4.29688 1.82129 5 1.82129C5.6875 1.82129 6.25 2.38379 6.25 3.07129C6.25 3.77441 5.6875 4.32129 5 4.32129Z",
    fill: "#314643"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLine);
export default __webpack_public_path__ + "static/media/icon-line.702fdab0a1cbd02cf493055715c8dd1f.svg";
export { ForwardRef as ReactComponent };